import { useEffect, useState } from "react";

export const useConvertInDataUrl = ({file}) => {
    const [dataUrl, setDataUrl] = useState(null);
   
    useEffect(() => {
        if (file && file?.type.includes('image')) {
            const reader = new FileReader();
            reader.onload = (e) => setDataUrl(e.target.result);
            reader.readAsDataURL(file);
        } else {
            setDataUrl(null);
        }
    }, [file]);

    return { dataUrl }
}